import React from 'react';

const Inventory = () => {
    return (
        <div>
            invemtory
        </div>
    );
};

export default Inventory;